import React, { Component, Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import './table.css'

class TableComponent extends Component {
	// constructor(props) {
	// 	super(props);
	// }
	render() {
		const { props } = this,
			{
				rows,
				columns,
				tablePage,
				rowsPerPage,
				rowsPerPageOptions = [10, 20, 30, 40, 50],
				handleChangePage,
				handleChangeRowsPerPage,
				showPager = true
			} = props;
		return (
			<Fragment>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								{columns.map(column => (
									<TableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{rows.slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage).map((row, index) => {
								return (
									<TableRow hover role='checkbox' tabIndex={-1} key={index}>
										{columns.map(column => {
											const value = row[column.id];
											return (
												<TableCell key={column.id} align={column.align}>
													{column.format ? column.format(value) : value}
												</TableCell>
											);
										})}
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				{
					showPager ? 
						<TablePagination
							rowsPerPageOptions={rowsPerPageOptions}
							component='div'
							count={rows.length}
							rowsPerPage={rowsPerPage}
							page={tablePage}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					 : null
				}
			</Fragment>
		);
	}
}
export default TableComponent;
